export interface DispatchFile {
  dispatchFileID: string;
  fileContentType: string;
  fileID: string;
  fileName: string;
  fileSize: number;
  fileType: string;
}
